module.exports = __webpack_public_path__ + "img/set-password.e27025a4.svg";